import React, {useRef} from 'react'
import styles from '../componentsStyles/Projects.module.css'

import { motion ,useScroll, useTransform } from 'framer-motion'

const ProjectsImagesMobile = () => {

  const imgRef = useRef(null);

  const {scrollYProgress} = useScroll({
    target:imgRef,
    offset: ["start end", "start start"]
  })

  const textOpacity = useTransform(scrollYProgress,
    [0.5, 0.9],
    [0, 1]  
  )

  const textSlide = useTransform(scrollYProgress,
    [0, 0.5, 0.8],
    ["-50%", "-25%", "0%"]
  )
  const textSlide1 = useTransform(scrollYProgress,
    [0, 0.6, 0.8],
    ["-50%", "-25%", "0%"]
  )
  const textSlide2 = useTransform(scrollYProgress,
    [0, 0.7, 0.8],
    ["-50%", "-25%", "0%"]
  )
  const textSlide3 = useTransform(scrollYProgress,
    [0, 0.75, 0.8],
    ["-50%", "-25%", "0%"]
  )

  


  return (
    <div className={styles.mobileImg}>
        
      <div className={styles.mobiHeight}>
        <div className={styles.mobiStikcy} ref={imgRef}>
          <div className={styles.mobiCenter}>
            <div className={styles.mobiImgContainer}>
              <img src="./images/task-handler-1.jpg" alt="not loaded..." />
            </div>
          </div>
          
          <motion.div className={styles.mobiText} style={{opacity: textOpacity, paddingTop: '2em'}} >

            <motion.h3 style={{x: textSlide}}> 
              Task handler App</motion.h3>
            <motion.p style={{x: textSlide}}>
            A management app that allows users to log in, create tasks, assign them to teams, and create objectives for each task according to its priority.
            </motion.p>
            <motion.p style={{x: textSlide1}}> 
             User authentication features, where the user kepps track of every change on the task.
            </motion.p>
            <motion.p style={{x: textSlide2}}>
             Task creation, tied to deadlines, description and task progress status.
            </motion.p>
            <motion.p style={{x: textSlide3}}>
              Teams creation, assosited with any speciic task, also fallowed by status and some other informtions
            </motion.p>

          </motion.div>


        </div>
      </div>

    </div>
  )
}

export default ProjectsImagesMobile